//

//import React, {ChangeEvent, useState, useEffect} from "react";
import React, { useState, useEffect } from "react";
import './quickacces.scss';
import { MIPALinksobj } from '../../Entity/Linkobj';
//import { useScreenshot } from 'use-react-screenshot'
//import { LinkPreview } from '@dhaiwat10/react-link-preview';
import { confirmAlert } from "react-confirm-alert";
//https://www.npmjs.com/package/@dhaiwat10/react-link-preview
interface Props {
  fnUpdateLink,
  link: MIPALinksobj,
  fnGetPrev
}
let defaultimag = "data:image/png;base64,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";
const LinkItem: React.FC<Props> = (props) => {
  const [imgdata, setimgdata] = useState<string>(defaultimag);
  useEffect(() => {
  }, [imgdata]);
  props.fnGetPrev(props.link.URL, data => {
    setimgdata(data);
  });
  return (
    <div className="linkitem" title={props.link.Description}>
      <div className="Actions">
        <i title="Edit" className="ms-Icon ms-Icon--EditSolid12" onClick={() => {
          props.fnUpdateLink('Update_LINK', props.link)
        }}></i>
        <i className="ms-Icon ms-Icon--ErrorBadge"
          onClick={() => {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <div className='custom-ui' style={{ backgroundColor: "#73afed" }}>
                    <h1>Are you sure?</h1>
                    <p>You want to delete this link?</p>
                    <button onClick={onClose}>No</button>
                    <button
                      onClick={() => {
                        props.fnUpdateLink('Delete_LINK', props.link);
                        onClose();
                      }}
                    >
                      Yes, Delete it!
                    </button>
                  </div>
                );
              }
            });

          }}
        ></i>
      </div>
      {/* <LinkPreview url='stripe.com' fetcher={customFetcher} fallback={<div>Fallback</div>} /> */}
      <div className="linkbody">
        {/*  <LinkPreview url={props.link.URL} width='83px' height='83px'
                showLoader={true}
                fallbackImageSrc={defaultimag}
                showPlaceholderIfNoImage={true}
                openInNewTab={true}
                fallback={<div>{props.link.URL}</div>}
                 />  */}
        <a href={props.link.URL} target="_blank">
          <img src={imgdata} width='83px' height='83px'></img>
        </a>

      </div>

      {/*  <a href={props.link.URL} target="_blank">
                {props.link.DisplayName}
                
                </a> */}
      <div className="linkdisplay">{props.link.DisplayName}</div>
      <div style={{ display: 'none' }}>{props.link.Description}</div>
    </div>
  );
}

export default LinkItem;